<template>
    <div>
        <PageBanner :pageTitle="$t('sidebar_inonlays_title')" />

        <InOnLaysDifference/>
    </div>
</template>

<script>
import InOnLaysDifference from '../blog-details/InOnLaysDifference.vue'
import PageBanner from '../Common/PageBanner'

export default {
    components: {
       PageBanner,
        InOnLaysDifference ,
    }
}
</script>